export const history = {
  alert: {
    alertsWithGPSTotal: "当前范围内的告警总数",
    authorized: "已授权",
    criticalItemFailed: "@:inspectionReport.criticalItemFailed",
    driver: "操作员",
    eventLocation: "事件地点",
    events: "事件",
    failedToGetLocation: "未能获取位置",
    failedToGetMoreData: "未能获取更多数据",
    fleet: "车间",
    last24hours: "过去24小时",
    listView: "列表模式",
    location: "地址",
    mapTypeBottomSwitch: "地图类型",
    mapView: "地图模式",
    messages: "通知",
    no: "否",
    seatBeltLowBattery: "安全带电池电量低",
    snapshotPhotos: "快照",
    speed: "速度",
    time: "时间",
    picture: "图片",
    video: "视频",
    unknownDriver: "@:common.global.unknownDriver",
    vehicleID: "设备编号",
    yes: "是",
    speedSensorLowBattery: "速度传感器电池电量低",
    sdCardError: "SD卡未识别",
    extDssSDCardError: "扩展SD卡未识别",
    driverRegistration: "司机登录",
    exporting: "导出中",
    exportDSSData: "驾驶行为导出",
    cameras: "摄像头",
  },
  alertSearch: { placeholder: "设备编号" },
  alertSelect: {
    DSSCameraBlocked: "驾驶行为-摄像头遮挡",
    DSSFatigue: "驾驶行为-疲劳",
    DSSPhone: "驾驶行为-使用手机",
    DSSSmoking: "驾驶行为-抽烟",
    geofencingEnter: "电子围栏-驶入",
    geofencingExit: "电子围栏-驶出",
    PDFrontCritical: "人员侦测-前方危险",
    PDLeftCritical: "人员侦测-左方危险",
    PDRearCritical: "人员侦测-后方危险",
    PDRightCritical: "人员侦测-右方危险",
    PDFrontRightCritical: "人员侦测-右前方危险",
    PDRearRightCritical: "人员侦测-右后方危险",
    seatbelt: "驾驶行为-未系安全带",
    speeding: "驾驶行为-超速",
    unauthorizedDriver: "未授权驾驶",
    hardHatOff: "未戴安全帽",
    cameraShift: "摄像头偏移",
    leaveSeat: "驾驶行为-离开座位",
    driverChanged: "驾驶行为-司机换人",
    cam1Alerts: "危险区违规闯入-摄像头1",
    cam2Alerts: "危险区违规闯入-摄像头2",
    cam1AlertsExempted: "危险区授权作业-摄像头1",
    cam2AlertsExempted: "危险区授权作业-摄像头2",
  },
  all: "所有",
  dataType: { alert: "警示", driver: "操作员", fleet: "车间", vehicle: "设备" },
  loading: "正在加载……",
  NA: "未知",
  noData: "@:common.global.noData",
  refresh: "刷新",
  trip: {
    authorized: "已授权",
    driver: "操作员",
    driverCamera: "驾驶摄像头",
    endLocation: "终点",
    fleet: "车间",
    frontCamera: "前摄像头",
    leftCamera: "左摄像头",
    model: "设备型号",
    notes: "备注",
    pleaseSelectACameraFirst: "请选择摄像头",
    rearCamera: "后摄像头",
    rightCamera: "右摄像头",
    secondsAfter: "后",
    secondsBefore: "前",
    selectCameras: "选择摄像头",
    sendUploadSuccessfully: "已发出请求。",
    startLocation: "起点",
    time: "时间",
    totalTime: "时长",
    distance: "里程",
    trip: "作业",
    uploadToCloud: "上传到云端",
    vehicleID: "设备编号",
    videoRetrieval: "视频采集",
    videoIsNotReady: "视频尚未就绪，请稍后再试",
    videoUploadQuotaReached: "上传的视频时长已达到上限。",
    start: "开始",
    end: "结束",
    back: "返回",
    frontRightCamera: "右前摄像头",
    rearRightCamera: "右后摄像头",
    exportTrip: "导出作业数据",
    averageSpeed: "平均速度",
    maxSpeed: "最高速度",
    speeding: "超速次数",
  },
  noGpsInfo: "没有GPS位置信息",
  Heat: "热力图",
  Bubble: "气泡图",
  noImage: "找不到图片或者视频",
};
